import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { OutfitRowData } from '../../types/admin';
import { ClothingItem } from '../../types';
import OutfitRow from './OutfitRow';

interface OutfitDataTableProps {
  rows: OutfitRowData[];
  onRowUpdate: (index: number, updates: Partial<OutfitRowData>) => void;
  onRowRemove: (index: number) => void;
  onClothingItemAdd: (rowIndex: number) => void;
  onClothingItemRemove: (rowIndex: number, itemIndex: number) => void;
  onClothingItemUpdate: (
    rowIndex: number,
    itemIndex: number,
    updates: Partial<ClothingItem>
  ) => void;
}

/**
 * OutfitDataTable renders a scrollable container of OutfitRow components
 * for the admin bulk upload page. Shows a count header and an empty state
 * message when no rows exist.
 */
const OutfitDataTable: React.FC<OutfitDataTableProps> = ({
  rows,
  onRowUpdate,
  onRowRemove,
  onClothingItemAdd,
  onClothingItemRemove,
  onClothingItemUpdate,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Outfits ({rows.length})
      </Typography>

      {rows.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 6,
            color: 'text.secondary',
          }}
        >
          <Typography variant="body1" color="text.secondary">
            No outfits added yet. Drag and drop images above to get started.
          </Typography>
        </Box>
      ) : (
        <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {rows.map((row, index) => (
            <OutfitRow
              key={row.id}
              row={row}
              rowIndex={index}
              onRowUpdate={onRowUpdate}
              onRowRemove={onRowRemove}
              onClothingItemAdd={onClothingItemAdd}
              onClothingItemRemove={onClothingItemRemove}
              onClothingItemUpdate={onClothingItemUpdate}
            />
          ))}
        </Box>
      )}
    </Paper>
  );
};

export default OutfitDataTable;
